<template>
  <u-deploy-panel>
    <template slot="title">
      {{ $t('title') }}
    </template>
    <template slot="content">
      <p>{{ $t('headline') }}</p>
      <p>{{ $t('content') }}</p>
      <p class="my-5 text-center"><img src="../assets/deploy.svg" /></p>
    </template>
    <template slot="actions">
      <a :href="docs" target="_blank">{{ $t('wizard.more') }}</a>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('cancel')">{{ $t('wizard.cancel') }}</v-btn>
      <v-btn color="primary" @click="$emit('next')">{{ $t('wizard.start') }}</v-btn>
    </template>
  </u-deploy-panel>
</template>

<script>
import DeployPanelComponent from '@/components/deploy/Panel.vue'
import { docsUrl } from '@/services/docs'

export default {
  data () {
    return {
      docs: docsUrl('manage')
    }
  },
  components: {
    'u-deploy-panel': DeployPanelComponent
  }
}

</script>

<i18n>
{
  "en": {
    "title": "Deploy Component",
    "headline": "This wizard will guide you in adding a new component to your Unryo system.",
    "content": "Once added, the component will be automatically connected, and will communicate securely and seamlessly with its peers, whether they are located on-premises or off-premises."
  }
}
</i18n>
